<div class="layout-sidebar">
    <div #menuContainer class="layout-menu-container">        
        @defer{
            <app-menu></app-menu>
           } @loading () {
            <p-progressSpinner ariaLabel="loading"/>
        }
    </div>
</div>
